module.exports = __webpack_public_path__ + "static/media/icing-yellow.9918a3b9.png";